import { Assignee } from 'infrastructure/enums';
import { mainlandTimezonesMapping } from 'infrastructure/data-sources/timezones';

import type {
  TDataFilterWithPaginationMeta,
  TDataFilter,
} from './use-rpm-overview-dashboard';

export interface BuildFilterOptions {
  withPagination?: boolean;
  itemsPerPage?: number;
}

export const buildRpmOverviewDashboardFilter = (
  filter: TDataFilterWithPaginationMeta,
  options: BuildFilterOptions = {},
): TDataFilter => {
  const { withPagination = false, itemsPerPage = 0 } = options;
  const { startTime, endTime, status, sorting, ...filterWithoutDates } = filter;

  const filterWithItems: TDataFilter = {
    ...filterWithoutDates,
    assignee: filter.assignee === Assignee.All ? undefined : filter.assignee,
    ...(withPagination && { items: itemsPerPage }),
    clinicGuid: filter.parentClinicGuid || filter.clinicGuid,
    childClinic: Boolean(filter.parentClinicGuid) || undefined,
    parentClinicGuid: undefined,
    year: endTime ? new Date(endTime).getFullYear() : undefined,
    month: endTime ? new Date(endTime).getMonth() + 1 : undefined,
    latestReadingStartTime: startTime,
    latestReadingEndTime: endTime,
    readingStatus: status,
    latestReading: sorting,
    parentClinicOption:
      filter.parentClinicOption && filter.clinicGuid
        ? filter.parentClinicOption
        : undefined,
    timezone: filter.timezone
      ? mainlandTimezonesMapping[filter.timezone]
      : undefined,
  };

  return filterWithItems;
};
